<!--
  Pricing.

  The site has never had this section. People only found out Ledgerly is a paid
  app once they reached the store. That was the biggest gap on the old page,
  and a bad way to meet a price.

  NO FIGURES. Prices are set per store with regional tiers, and the app never
  computes or hardcodes one. It renders whatever string the store returns
  through RevenueCat, and even the yearly saving percentage is worked out at
  runtime from the two prices the store reports. A number printed here would be
  wrong in most of the world and stale in the rest. Say what shape the offer
  is, and let the store say the price.

  Plan order is yearly, lifetime, monthly: the app's own order, and the code
  says why: "lifetime second because it is what makes yearly read as modest;
  monthly last because it is the escape, not the offer."
-->
<section id="pricing" class="bg-ground py-[112px]">
  <div class="mx-auto max-w-[1180px] px-8">
    <div class="max-w-[60ch]">
      <p
        class="text-kicker uppercase text-accent reveal"
        appReveal
        i18n="@@pricingKicker"
      >
        What it costs
      </p>
      <h2
        class="mt-kicker-gap text-headline text-ink text-balance reveal"
        appReveal
        i18n="@@pricingHeadline"
      >
        Free to start, then you decide.
      </h2>
      <p
        class="mt-8 text-body text-ink-2 reveal"
        appReveal
        i18n="@@pricingIntro"
      >
        You can start recording for free, with everything unlocked from day
        one. When you want to keep going, pick a plan. There is no second tier
        and nothing saved up for a bigger plan.
      </p>
    </div>

    <div class="mt-[56px] grid gap-8 md:grid-cols-3">
      @for (plan of plans; track plan.name; let i = $index) {
      <div
        class="reveal flex flex-col rounded-lg border p-8"
        [class]="
          plan.emphasis
            ? 'border-accent-stroke bg-surface'
            : 'border-line bg-surface/60'
        "
        [appReveal]="i * 80"
      >
        <div class="flex items-baseline justify-between">
          <p class="text-row-amount text-ink">{{ plan.name }}</p>
          @if (plan.badge) {
          <span
            class="rounded-pill border border-accent-stroke px-3 py-1 text-kicker uppercase text-accent"
            >{{ plan.badge }}</span
          >
          }
        </div>

        <p class="mt-6 text-body text-ink-2">{{ plan.terms }}</p>

        <p class="mt-auto pt-8 text-sub text-ink-2">{{ plan.note }}</p>
      </div>
      }
    </div>

    <p class="mt-8 text-sub text-ink-2" i18n="@@pricingStoreNote">
      The App Store and Google Play set the price for each country, so what you
      see is the price where you are. Open either listing to check it.
    </p>

    <!--
      The honest bit, and the one almost nobody says out loud. It is also
      exactly what the app says: everything you have already recorded stays
      readable and exportable, and Pro is what lets you keep recording.
    -->
    <div
      class="reveal mt-[56px] rounded-lg border border-line bg-surface p-8 md:p-[42px]"
      appReveal
    >
      <p class="text-kicker uppercase text-accent" i18n="@@pricingAfterKicker">
        If you do not buy
      </p>
      <p
        class="mt-kicker-gap max-w-[46ch] text-[24px] font-medium leading-[1.3] tracking-[-0.015em] text-ink text-balance"
        i18n="@@pricingAfterHeadline"
      >
        Nothing you wrote down gets locked away.
      </p>
      <p class="mt-6 max-w-[64ch] text-body text-ink-2" i18n="@@pricingAfterBody">
        You can still read, search, export and back up whether you buy or not.
        Paying is what lets you add new transactions. Nothing you have already
        written down gets held back, and the CSV export is there on the day you
        decide to leave.
      </p>

      <div class="mt-[42px] flex flex-wrap items-center gap-8">
        <layout-store-badges location="pricing" />
        <p class="text-sub text-ink-2" i18n="@@pricingRestore">
          Bought with your App Store or Google Play account. Tap Restore on any
          device you sign in to.
        </p>
      </div>
    </div>
  </div>
</section>
